import { useAddressById } from '@entities/schedules/address/model';
import type { FC} from 'react';
import { memo } from 'react';

import { Close, Location } from '@shared/assets';
import { IconButton } from '@shared/ui';

import { getPhoneNumber, validAddress } from './lib';
import * as st from './styles.module.scss';

interface Props {
	id: number;
	index: number;
	handler: (id: number) => void;
	isDisabled?: boolean;
}

export const AddressCard: FC<Props> = memo(({ id, index, isDisabled, handler }) => {
	const { address } = useAddressById(id);

	return (
		<div className={st.card}>
			<div className={st.index}>
				<div className={st.icon}>
					<Location />
				</div>
				<p className={st.number}>{index + 1}</p>
			</div>
			<div className={st.border} />
			<div className={st.info}>
				<div className={st.table}>
					<div className={st.title}>Адрес</div>
					<div className={st.about}>{address && validAddress(address)}</div>
				</div>
				<div className={st.table}>
					<div className={st.title}>Контактный телефон</div>
					<div className={st.about}>
						<p className={st.phone}>{address && getPhoneNumber(address?.phone)}</p>
					</div>
				</div>

				<div className={st.table}>
					<div className={st.title}>Комментарий для клиента</div>
					<div className={st.about}>
						<p className={st.note}>{address && address?.note}</p>
					</div>
				</div>
			</div>
			<div className={st.delete}>
				<IconButton
					variant="transparent"
					className={st.close}
					type="button"
					disabled={isDisabled}
					onClick={() => handler(id)}
				>
					<Close />
				</IconButton>
			</div>
		</div>
	);
});
